import { Advertiser } from './advertiser';
import { Brand } from './brand';

export enum IntegrationInviteStatus {
  pending = 'pending',
  disabled = 'disabled',
  expired = 'expired',
  completed = 'completed'
}

export interface IntegrationInvite {
  id: string;
  advertiser: Advertiser | any;
  brand: Brand | any;
  email: string;
  name: string;
  integrations: Array<string>;
  status: IntegrationInviteStatus;

  expDate: Date;
  createdDate: Date;
  link: string;
  token: string;
  completed?: boolean
  completedDate?: Date;
  disabledDate?: Date;
}
